// ======================================================================
// File Name       : superuserServiceRole
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { SUPERUSER_ENTERPRISE_ROLE_RECEIVE_LIST } from '../constants/ActionTypes';

const initialState = {
  authorityInfo: {
    roleList: [],
    bySecernId: {},
  },
};

export default function authority(state = initialState, action) {
  switch (action.type) {
    case SUPERUSER_ENTERPRISE_ROLE_RECEIVE_LIST: {
      const { roleList } = action;
      const authorityInfo = roleList.reduce(
        (acc, cur) => {
          const { superuserEnterpriseRoleSecernId } = cur;
          acc.bySecernId[superuserEnterpriseRoleSecernId] = cur;
          return acc;
        },
        { bySecernId: {}, roleList },
      );
      return { ...state, authorityInfo };
    }

    default:
      return state;
  }
}
